/**
 * Defines strong types for experiments, such that whenever the given key is used
 * the variations will be typed appropriately to its value.
 */
export interface Experiments {
  upsell_basic_flowcode_limit: 'PRO' | 'PRO_PLUS'
  user_cohorts: string
}
export const PRINT_STORE_PRICE_CARD_TEST = 'print_store_price_card_test'
export const TEMPLATES_ENTRY_POINT_TEST = 'templates_entry_point_test'
export const REMOVE_BUILD_FROM_SCRATCH_CARD_TEST = 'remove_build_from_scratch_card_test'
export const REDESIGNED_NAVIGATION_AND_FLOWLYTICS_LANDING_PAGE_AB_TEST =
  'redesigned_navigation___flowlytics_a_b_test'
export const LOGGED_OUT_CODE_GENERATOR_V2_TEST = 'logged_out_code_generator_v2_test'
